import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const RemoteWork = () => {
  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }}
      className="max-w-7xl mx-auto"
    >
      <h1 className="section-title">Remote Work Implementation</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Availability Visualizer */}
        <div className="section-card">
          <h2 className="subsection-title">Availability Window (EST)</h2>
          <div className="relative h-24 bg-beige/50 rounded-lg overflow-hidden flex items-center px-4 mb-6 border border-gold/10">
            {/* Day Blocks */}
            <div className="absolute left-[10%] right-[10%] h-12 bg-gold/20 rounded flex items-center justify-center text-brown font-bold border border-gold/30">
              9:00 AM — 6:00 PM (Core Hours)
            </div>
            <div className="absolute left-[10%] top-0 bottom-0 w-0.5 bg-gold opacity-30"></div>
            <div className="absolute right-[10%] top-0 bottom-0 w-0.5 bg-gold opacity-30"></div>
          </div>
          
          <div className="space-y-3">
            <div className="flex items-center p-3 bg-apache/10 rounded-lg text-apache text-sm">
              <SafeIcon name="CheckCircle" className="mr-3" />
               Response Time: &lt; 2 Hours
            </div>
            <div className="flex items-center p-3 bg-gold/10 rounded-lg text-brown text-sm">
              <SafeIcon name="AlertTriangle" className="mr-3 text-gold" />
               Emergency: &lt; 1 Hour
            </div>
          </div>
        </div>

        {/* Deliverables List */}
        <div className="section-card">
          <h2 className="subsection-title">Weekly Deliverables (Friday 6PM)</h2>
          <div className="space-y-2">
            {[
              'Content Calendar (Next Week)',
              'Performance Summary PDF',
              'Creative Asset Requests',
              'Trend Research Report'
            ].map((item, i) => (
              <motion.div 
                key={i}
                whileHover={{ x: 5 }}
                className="flex items-center p-3 border border-gold/10 rounded-lg hover:bg-beige transition-colors"
              >
                <SafeIcon name="FileText" className="text-gold mr-3" />
                <span className="text-brown font-medium">{item}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      <div className="section-card mt-6">
        <h2 className="subsection-title">Approval Workflow Stages</h2>
        <div className="flex items-center justify-between relative">
          <div className="absolute left-0 right-0 top-1/2 h-0.5 bg-gold/20 -z-10"></div>
          {['Draft', 'Internal', 'Client Rd 1', 'Revisions', 'Final', 'Schedule'].map((stage, i) => (
            <div key={i} className="flex flex-col items-center bg-white px-2">
              <div className="w-8 h-8 rounded-full bg-brown text-gold flex items-center justify-center text-xs font-bold mb-2">
                {i+1}
              </div>
              <span className="text-xs font-medium text-brown/70">{stage}</span>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default RemoteWork;